define('lq/services/mpa/pasteCommand',[
    'jquery',
    'underscore'
], function ($, _) {
    'use strict';

    var filePastedEvent = 'filePasted';
    var textPastedEvent = 'textPasted';

    function PasteCommand(data) {
        this.data = data;
    };

    PasteCommand.typeName = 'PasteCommand';

    PasteCommand.prototype.initialize = function () {
        if (!this.shouldListenForPaste()) return;
        this.addEventHandlers();
    };

    PasteCommand.prototype.shouldListenForPaste = function () {
        return this.shouldListenFor(filePastedEvent) || this.shouldListenFor(textPastedEvent);
    };

    PasteCommand.prototype.shouldListenFor = function (eventName) {
        return this.data.eventing
            && this.data.eventing[eventName]
            && this.data.eventing[eventName].enabled;
    };

    PasteCommand.prototype.addEventHandlers = function () {
        var self = this;

        document.onpaste = function (event) {
            var items = (event.clipboardData || event.originalEvent.clipboardData).items;

            var image = _.find(items, function (item) { return item.kind === 'file'; });

            if (image) {
                if (self.shouldListenFor(filePastedEvent))
                    self.piping.eventing.publish(self.data.eventing[filePastedEvent].raisedEventName, null, image.getAsFile());
            } else if (self.shouldListenFor(textPastedEvent)) {
                var text = _.find(items, function (item) { return item.kind === 'string'; });

                if (text) {
                    text.getAsString(function (textData) {
                        self.piping.eventing.publish(self.data.eventing[textPastedEvent].raisedEventName, null, textData);
                    });
                } 
            }
        }
    }

    return PasteCommand;
});
